(function ($, Drupal, drupalSettings) {
  Drupal.behaviors.question_modal = {
    attach: function (context) {
      // Latex descriptions
      var MQ = MathQuill.getInterface(2);
      MQ.config({
        autoOperatorNames: "sins",
      });
      $(".latex-string", context)
        .once()
        .each(function (key, value) {
          var $this = $(value);
          var text = $this.text();
          if ($this.find(".math-input").length < 1) {
            $(
              '<span class="math-input math-input--string" id="math-input"></span>'
            ).insertAfter($this);
            var answerMathField = MQ.MathField($this.next("#math-input")[0]);
            answerMathField.write(text);
            var $mathInputDisplay = $this.next("#math-input");
            $mathInputDisplay.removeClass("mq-editable-field");
            $mathInputDisplay
              .find(".mq-textarea textarea")
              .prop("disabled", true);
          }
        });

      // Marking forms - quizlet info
      if ($(".marking-form", context).length > 0) {
        $(".marking-form", context).each(function () {
          var $this = $(this);
          var $additional = $this.find(".marking-form__additional");
          var $studentAnswer = $this.find(".marking-form__answer");
          if ($additional.length > 0) {
            $studentAnswer.addClass("marking-form__student-answer--additional");
          }
          $additional.appendTo($studentAnswer);
        });
      }
    },
  };
})(jQuery, Drupal, drupalSettings);
